import ModelContainer from "@core/scripts/components/model-container";
import ImageSourceHelper from "../image/image-source-helper";


function load() {

    if(window.productModelDecompressed) {
        return ModelContainer.get("productModel");
    }

    const imageContext = ModelContainer.get("imageContext");
    const productModel = ModelContainer.get("productModel");
    let {product} = productModel;

    //resolves all image definition into the old structure
    product = ImageSourceHelper.resolveImageSources(imageContext, product);

    const currentStyle = product.styles[product.currentStyleIndex];
    const currentItem = currentStyle.items[product.currentItemIndex];
    const currentItemOption = currentItem.itemOptions[product.currentItemOptionIndex];

    product.currentStyle = currentStyle;
    product.currentItem = currentItem;
    product.currentItemOption = currentItemOption;
    productModel.product = product;

    window.modelContainer.productModel = productModel;
    window.productModelDecompressed = true;

    return productModel;
}

export default {
    load
};



